// extracted by mini-css-extract-plugin
module.exports = {"guaranteesWrap":"home-banners_guaranteesWrap____cqM"};